import styled, { css, keyframes } from "styled-components";
import { palette } from "@conserveit/blocks";

const anim = keyframes`
  0%, 80%, 100% {
    transform: scale(0);
  }

  40% {
    transform: scale(1.0);
  }
`;

const animationRule = css`
  ${anim} 1.4s infinite ease-in-out both
`;

const $LoadingItem = styled.div`
  width: 24px;
  height: 24px;
  background-color: ${palette.neutral4};
  border-radius: 100%;
  display: inline-block;
  animation: ${animationRule};

  &:nth-child(1) {
    animation-delay: -0.32s;
  }

  &:nth-child(2) {
    animation-delay: -0.16s;
  }
`;

const $Loading = styled.div`
  display: flex;
  justify-content: space-evenly;
  text-align: center;
  width: 100px;
  margin: 0 auto;
`;

export { $Loading, $LoadingItem };
